import React from 'react';

const Status = ({ rowData }) => {
    return (
        <span>
            {
            rowData.status === "o" ?
            "جاری" :
            rowData.status === "c" ?
            "بسته شده":
            rowData.status === "a" &&
            "پاسخ داده شده"
            }
        </span>
    );
}

export default Status;
